import { render } from "./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=64ef1993"
import script from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"
export * from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"
script.render = render

export default script